module.exports = __webpack_public_path__ + "statics/img/4.3e0333d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo/4.jpg
// module id = /t7S
// module chunks = 1